import React from "react";
import { Grid, Column } from "@carbon/react";
import Nav from "./Nav";

function WorkExperience() {
  return (
    <Grid>
      <Column lg={16} md={8} sm={4} style={{ marginTop: '80px' }}>
        <Nav />
      </Column>
      <Column lg={16} md={8} sm={4} style={{ marginTop: '80px' }}>
        <Grid>
          <Column md={8} lg={7} sm={4}>
            <h1 className="bx--type-expressive-heading-01">Software Engineer</h1>
            <h2 className="bx--type-expressive-heading-01">Openjaw Technologies, Galway</h2>
            <h3 className="bx--type-expressive-heading-01">August 2021 - Present</h3>
          </Column>
        </Grid>
      </Column>
      <Column lg={16} md={8} sm={4} style={{ marginTop: '20px' }}>
        <Grid>
          <Column md={8} lg={10} sm={4}>
              <p>· Build and extend Java/Spring Boot microservices supporting hotel search, booking, pricing, loyalty, profile management and events, integrating with third-party PMS systems through OTA XML messaging.
</p>
            <p>·  Own features end-to-end, from analysing business requirements and working with client stakeholders through
technical design, implementation, testing, release and go-live, on a platform serving 130+ luxury properties
worldwide.</p>
            <p>· Implement and modify XML/XSLT business rules controlling routing, pricing, promotions and booking logic
within a middleware rules engine processing thousands of daily transactions.</p>
            <p>· Investigate and resolve application issues by reproducing reported problems, tracing request/response flows across
distributed services and analysing application logs to identify the underlying cause and implement a fix.
</p>
  <p>· Coordinate releases across development, QA, pre-production and production environments using Jenkins to support builds and automated deployment.
</p>
          </Column>
        </Grid >
      </Column>
      <Column lg={16} md={8} sm={4} style={{ marginTop: '80px' }}>
        <Grid>
          <Column md={8} lg={7} sm={4}>
            <h1 className="bx--type-expressive-heading-01">Intern Software Developer</h1>
            <h2 className="bx--type-expressive-heading-01">Openjaw Technologies, Galway</h2>
            <h3 className="bx--type-expressive-heading-01">January 2020 - March 2020</h3>
          </Column>
        </Grid>
      </Column>
      <Column lg={16} md={8} sm={4} style={{ marginTop: '20px', marginBottom: '20px' }}>
        <Grid>
          <Column md={8} lg={10} sm={4}>
            <p>· Developed React frontend features and Java/Spring Boot REST services for an AI customer service chatbot and
agent dashboard used in the aviation industry.</p>
            <p>· Practised test-driven development, writing unit and integration tests in Java and automated UI tests with Selenium WebDriver. </p>
            <p>· Built a dashboard enabling customer service agents to create and modify chatbot intents.</p>
          </Column>
        </Grid >
      </Column >
    </Grid >
  );
}

export default WorkExperience;
